import { createFileRoute } from "@tanstack/react-router";

import { CnCallReviewDashboard } from "../tools/dashboards/CnCallReviewDashboard";

function CnCallReviewRoute() {
  return <CnCallReviewDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/cn-call-review")({
  component: CnCallReviewRoute,
});
